import React from 'react';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ProfileCustomClearIcon from '../../../HelperIcons/ProfileCustomClearIcon';
import ProfileCustomDeleteIcon from '../../../HelperIcons/ProfileCustomDeleteIcon';

const CustomTextField = ({ field, index, handleFieldChange, handleClearField, handleDeleteField, shudDeleteBtnRender, shudClearBtnRender }) => {
  return (
    <TextField
      key={field.id}
      value={field.value}
      disabled={field.disabled}
      onChange={(event) => handleFieldChange(index, event)}
      sx={{
        '& .MuiInput-underline:before': {
          borderBottom: 'none',
        },
        '& .MuiInput-underline:after': {
          borderBottom: 'none',
        },
        '& .MuiInputBase-root.MuiInputBase-root.MuiInputBase-root:before': {
          borderBottom: 'none',
        },
        '& .MuiInputBase-root': {
          fontWeight: '400',
          fontSize: '14px',
          color: "red !important",
          fontFamily: "Figtree,sans-serif !important",
          WebkitTextFillColor: "#4f5b7d"
        },
        borderBottom: '1px solid #E7E7FF',
        padding: '10px',
        outline: 0,
      }}
      variant="standard"
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" sx={{ marginRight: '10px' }}>
            {shudClearBtnRender && (
              <IconButton
                aria-label="clear"
                onClick={(e) => handleClearField(index, e)}
                disabled={field.disabled}
                edge="end"
                sx={{ marginRight: '8px' }}
              >
                <ProfileCustomClearIcon
                  sx={{
                    backgroundColor: field.disabled ? 'transparent' : 'lightgrey',
                    color: 'white',
                    borderRadius: '50%',
                    width: '18px',
                    height: '18px',
                  }}
                />
              </IconButton>
            )}
            {shudDeleteBtnRender && (
              <IconButton
                aria-label="delete"
                onClick={() => handleDeleteField(index)}
                disabled={field.disabled}
                edge="end"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <ProfileCustomDeleteIcon
                  sx={{ width: '20px', height: '20px' }}
                  color={field.disabled ? 'transparent' : '#F74646'}
                />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default CustomTextField;
